import { clsx } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs) {
  return twMerge(clsx(inputs))
}

// Format number with Spanish locale (1.234,56)
export function formatNumber(num, decimals = 0) {
  if (num === null || num === undefined) return '-';
  return new Intl.NumberFormat('es-ES', {
    minimumFractionDigits: decimals,
    maximumFractionDigits: decimals,
  }).format(num);
}

// Format currency
export function formatCurrency(num, currency = 'USD') {
  if (num === null || num === undefined) return '-';
  return new Intl.NumberFormat('es-ES', {
    style: 'currency',
    currency,
    minimumFractionDigits: 0,
    maximumFractionDigits: 0,
  }).format(num);
}

// Format percentage
export function formatPercent(num, decimals = 1) {
  if (num === null || num === undefined) return '-';
  return `${formatNumber(num, decimals)}%`;
}

// Format date
export function formatDate(dateStr) {
  if (!dateStr) return '-';
  const date = new Date(dateStr);
  return new Intl.DateTimeFormat('es-ES', {
    year: 'numeric',
    month: 'short',
  }).format(date);
}

// Format month for display
export function formatMonth(monthStr) {
  if (!monthStr) return '-';
  const [year, month] = monthStr.split('-');
  const date = new Date(year, parseInt(month) - 1);
  return new Intl.DateTimeFormat('es-ES', {
    year: 'numeric',
    month: 'short',
  }).format(date);
}

// Get status color classes
export function getStatusColor(status) {
  switch (status) {
    case 'green':
      return 'bg-emerald-500';
    case 'yellow':
      return 'bg-amber-400';
    case 'red':
      return 'bg-rose-500';
    default:
      return 'bg-slate-400';
  }
}

// Get status badge classes
export function getStatusBadge(status) {
  switch (status) {
    case 'green':
      return 'bg-emerald-50 text-emerald-700 border-emerald-200';
    case 'yellow':
      return 'bg-amber-50 text-amber-700 border-amber-200';
    case 'red':
      return 'bg-rose-50 text-rose-700 border-rose-200';
    default:
      return 'bg-slate-50 text-slate-700 border-slate-200';
  }
}

// Get trend indicator
export function getTrendIndicator(value) {
  if (value > 0) return { icon: '↑', color: 'text-emerald-600' };
  if (value < 0) return { icon: '↓', color: 'text-rose-600' };
  return { icon: '→', color: 'text-slate-500' };
}

// Chart colors from design guidelines
export const chartColors = {
  primary: '#6366F1',
  secondary: '#10B981',
  tertiary: '#F59E0B',
  quaternary: '#EF4444',
  quinary: '#8B5CF6',
};

// Route colors for charts
export const routeColors = {
  'MVD→MIA': '#6366F1',
  'MVD→GRU': '#10B981',
  'MVD→SCL': '#F59E0B',
  'MVD→NYC': '#EF4444',
  'MVD→MAD': '#8B5CF6',
  'MVD→EZE': '#EC4899',
  'MVD→BOG': '#14B8A6',
  'MVD→LIM': '#F97316',
};
